const defaultLocale = "en";
const locales = [defaultLocale, "de"];

module.exports = { locales, defaultLocale };
